import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
//api
import { getUserLibraryContest } from 'api/users';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchLibraryUsersInput = ({
  onSelected,
  placeholder = null,
  defaultClient = null,
  filterBy,
  fields = 'email,username',
  profile = 'library',
  label,
  onClearError
}) => {
  const { t } = useTranslation(['backoffice']);
  const [clientSelected, setClientSelected] = useState(null);

  useEffect(() => {
    if (defaultClient) {
      setClientSelected({
        label: filterBy === 'email' ? defaultClient.email : defaultClient.username,
        value: defaultClient.id,
      });
    } else setClientSelected(null)
  }, [defaultClient, filterBy]);

  const onSearch = async (value) => {
    if (value.length > 0 && onClearError) onClearError();
    if (value.length > 1) {
      const { status, data } = await getUserLibraryContest({
        profile,
        [filterBy]: value,
        page: 1,
        page_size: 10,
        fields
      });
      if (status === 200) {
        const results = data?.results?.map((item) => {
          return {
            ...item,
            label: item.email || item.username,
            value: item.id,
          };
        })
        return results;
      }
    }
    return [];
  };

  return (
    <AutoCompleteInput
      defaultOptions={clientSelected ? clientSelected : []}
      defaultValue={clientSelected}
      label={label || t('libraryUsers')}
      placeholder={placeholder || t('searchByEmailUsername')}
      onSelect={onSelected}
      onSearch={onSearch}
    />
  );
};

SearchLibraryUsersInput.propTypes = {
  filterBy: PropTypes.string.isRequired,
  onSelected: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  defaultClient: PropTypes.any,
  fields: PropTypes.string,
  profile: PropTypes.string,
  label: PropTypes.string,
  onClearError: PropTypes.func
};

export default SearchLibraryUsersInput;
